module.exports = __webpack_public_path__ + "img/system2.ef27a8f1.svg";